import React, { useEffect, useState, useRef } from "react";

import {
  TooltipBubble,
  TooltipMessage,
  TooltipTrigger,
  TooltipContainer,
} from "./tooltip/TooltipStyle";

export const Tooltip = ({ message, position, width, children }) => {
  const [displayTooltip, setDisplayTooltip] = useState(false);
  const [offsetHeight, setOffsetHeight] = useState(0);

  /**
   * Reference to the children component to track width and height
   */
  const nodeTrigger = useRef();

  useEffect(
    () => {
      setOffsetHeight(nodeTrigger.current.offsetHeight);
    },
    [nodeTrigger]
  );

  return (
    <TooltipContainer onMouseLeave={() => setDisplayTooltip(false)}>
      {displayTooltip && (
        <TooltipBubble
          position={position}
          offsetHeight={offsetHeight}
          width={width}
        >
          <TooltipMessage>{message}</TooltipMessage>
        </TooltipBubble>
      )}
      <TooltipTrigger
        onMouseOver={() => setDisplayTooltip(true)}
        ref={nodeTrigger}
      >
        {children}
      </TooltipTrigger>
    </TooltipContainer>
  );
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Tooltip.js